/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
const routes = [
  {
    path: "/app/facilities",
    icon: "CartIcon",
    name: "Facility",
  },
  { path: "/app/old-bills",
    icon: "DocumentTextIcon",
    name: "Old Bills" },
  {
    path: "/app/sheet-changes",
    icon: "OutlinedThemeIcon",
    name: "Sheet Changes",
  },
  {
    path: '/app/payment-verification',
    name: 'Payment Verification',
    icon: 'CheckCircleIcon',
    layout: '/app',
  },
  {
    path: "/app/users",
    icon: "PagesIcon",
    name: "Users",
  },
  {
    path: "/app/login-history",
    icon: "HistoryIcon",
    name: "Login History",
  },
  {
    path: "/app/pending-amount-logs",
    icon: "HistoryIcon",
    name: "Pending Amount Logs",
    adminOnly: true,
  },
  {
    path: "/app/employees",
    icon: "PeopleIcon",
    name: "Employees",
  },
  {
    path: "/app/moderators",
    icon: "PeopleIcon",
    name: "Moderators",
  },
  {
    path: "/app/addfacility",
    icon: "FormsIcon",
    name: "Add Facility",
  },
  {
    path: "/app/invoice",
    icon: "FormsIcon",
    name: "Invoice Generation",
  },
  {
    path: "/app/adduser",
    icon: "FormsIcon",
    name: "Add User",
  },
  {
    path: "/app/addmoderator",
    icon: "PeopleIcon",
    name: "Add Moderator",
  },
  {
    path: "/app/addemployee",
    icon: "FormsIcon",
    name: "Add Employee",
  },
  {
    path: "/app/document",
    icon: "FormsIcon",
    name: "Document",
  },

  {
    path: "/app/generateqr",
    icon: "FormsIcon",
    name: "Generate QR",
  },
  {
    path: "/app/generatecertificate",
    icon: "FormsIcon",
    name: "GRS Doc",
    adminOnly: true,
  },

  {
    path: "/app/complaints",
    icon: "PeopleIcon",
    name: "Complaints",
  },
  {
    path: "/app/pdf",
    icon: "FormsIcon",
    name: "Generate Reports",
  },
  {
    path: "/app/reports",
    icon: "FormsIcon",
    name: "Reports",
  },
  {
    path: "/app/addfieldagent",
    icon: "FormsIcon",
    name: "Add Field Agent",
    adminOnly: true,
  },
  {
    path: "/app/field-agents",
    icon: "PeopleIcon",
    name: "Field Agents",
  },
];

export default routes;
